import { Link } from "react-router-dom";
import { LogoStacked } from "./Logo";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-navy-footer text-white"
        >
            <div className="mx-auto max-w-[1240px] px-4 md:px-6 lg:px-12 py-12 md:py-16 flex flex-col gap-8 md:gap-10">
                <div className="grid grid-cols-2 gap-x-6 gap-y-8 md:flex md:flex-wrap md:gap-14">
                    {/* Brand column */}
                    <div className="col-span-2 flex-[1_1_300px] flex flex-col gap-4">
                        <LogoStacked fodWidth={132} />
                        <p className="text-[14px] leading-relaxed text-on-navy-soft max-w-sm m-0">
                            FOD est la marque de DMB Partners, spécialiste de l'optimisation des frais
                            bancaires des PME et ETI.
                        </p>
                        <Link
                            to="/simulateur"
                            data-testid="footer-cta"
                            className="self-start inline-flex items-center bg-gold text-navy font-semibold text-sm h-11 px-5 rounded-md hover:-translate-y-[1px] transition-all"
                        >
                            Simuler mes économies
                        </Link>
                    </div>

                    {/* Navigation column */}
                    <nav
                        aria-label="Navigation du pied de page"
                        className="flex-[1_1_160px] flex flex-col gap-0 md:gap-3 text-[15px] md:text-sm"
                    >
                        <span className="text-[12px] font-semibold uppercase tracking-[0.14em] text-gold mb-1 md:mb-0">
                            Navigation
                        </span>
                        <Link to="/a-propos" className="text-white hover:text-gold py-2.5 md:py-0">À propos</Link>
                        <Link to="/tarifs" className="text-white hover:text-gold py-2.5 md:py-0">Tarifs</Link>
                        <Link to="/actualites" className="text-white hover:text-gold py-2.5 md:py-0">Actualités</Link>
                        <Link to="/simulateur" className="text-white hover:text-gold py-2.5 md:py-0">Simulateur</Link>
                        <Link to="/faq" data-testid="footer-faq-link" className="text-white hover:text-gold py-2.5 md:py-0">FAQ</Link>
                        <Link to="/contact" className="text-white hover:text-gold py-2.5 md:py-0">Contact</Link>
                    </nav>

                    {/* Legal column */}
                    <nav
                        aria-label="Informations légales"
                        className="flex-[1_1_200px] flex flex-col gap-0 md:gap-3 text-[15px] md:text-sm"
                    >
                        <span className="text-[12px] font-semibold uppercase tracking-[0.14em] text-gold mb-1 md:mb-0">
                            Légal
                        </span>
                        <Link to="/mentions-legales" data-testid="footer-mentions-link" className="text-white hover:text-gold py-2.5 md:py-0">Mentions légales</Link>
                        <Link to="/politique-de-confidentialite" data-testid="footer-privacy-link" className="text-white hover:text-gold py-2.5 md:py-0">Politique de confidentialité</Link>
                        <Link to="/conditions-utilisation" data-testid="footer-cgu-link" className="text-white hover:text-gold py-2.5 md:py-0">Conditions d'utilisation</Link>
                        <button type="button" data-testid="footer-cookie-settings" onClick={() => window.dispatchEvent(new Event("fod-open-cookie-banner"))} className="text-left text-white hover:text-gold py-2.5 md:py-0">Gérer les cookies</button>
                    </nav>

                    {/* Contact column */}
                    <div className="col-span-2 flex-[1_1_220px] flex flex-col gap-0 md:gap-3 text-[15px] md:text-sm leading-relaxed">
                        <span className="text-[12px] font-semibold uppercase tracking-[0.14em] text-gold mb-1 md:mb-0">
                            Contact
                        </span>
                        <a href="mailto:contact@fodbydmb.com" className="text-white hover:text-gold py-2.5 md:py-0">
                            contact@fodbydmb.com
                        </a>
                        <span className="text-on-navy-soft py-2 md:py-0">
                            149 avenue du Maine
                            <br />
                            75014 Paris
                        </span>
                        <a
                            href="https://www.linkedin.com/company/dmb-partners/"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-linkedin"
                            className="text-white hover:text-gold py-2.5 md:py-0"
                        >
                            LinkedIn DMB Partners
                        </a>
                    </div>
                </div>

                <div data-testid="footer-medef" className="border-t border-[rgba(255,255,255,0.12)] pt-[22px] flex items-center gap-4">
                    <a href="https://www.medefparis.fr/" target="_blank" rel="noopener noreferrer" aria-label="MEDEF Paris (nouvel onglet)" data-testid="footer-medef-link" className="shrink-0 bg-white rounded-[6px] px-3 py-2 inline-flex transition-opacity hover:opacity-85">
                        <img src="/media/medef-paris.png" alt="MEDEF Paris" loading="lazy" className="h-10 w-auto" />
                    </a>
                    <span className="flex flex-col gap-0.5">
                        <span className="text-white text-[14px] font-semibold">DMB Partners est adhérent du MEDEF Paris</span>
                        <span className="text-[#9AA3B2] text-[12px]">FOD est une marque de DMB Partners</span>
                    </span>
                </div>

                <div className="border-t border-navy-outline pt-5 flex flex-wrap justify-between gap-2 text-[13px] md:text-[12px] text-on-navy-faint">
                    <span>© {new Date().getFullYear()} DMB Partners · SAS au capital de 1 000 € · RCS Paris 928 053 487</span>
                </div>
            </div>
        </footer>
    );
}
